import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  iconName,
  pluginName,
  qualify,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {UsysUtilityPageConstraint, extraAttrs} from './utils';
import {
  USYS_INPUT_TYPES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {TText, TRecord, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {appendUserInputClasses} from '@packages/systems/users/utils/universalUtils';
import {useRuntimeEnvironment} from '@packages/systems/render';

const {DESIGNER} = WebflowEnvironments;

const UserFormEmailInput = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data}) => {
    const inputClasses = appendUserInputClasses(data, classes);
    const runtimeEnvironment = useRuntimeEnvironment();
    const mockValue = context.get('data')?.email;

    // Set mock user email as value for user account page
    if (runtimeEnvironment === DESIGNER && mockValue)
      attributes = attributes.set('value', mockValue);

    return (
      <input
        {...generateAttributes(attributes, inputClasses)}
        type="email"
        autoComplete="username"
        required
        {...{[USYS_DATA_ATTRS.inputType]: USYS_INPUT_TYPES.email}}
      />
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'User Email Field',
  constraints: {
    page: [UsysUtilityPageConstraint],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: UserFormEmailInput,
  fields: {
    attr: TRecord(
      {
        placeholder: withSystem(
          {label: 'Placeholder', isFullWidth: true},
          TText
        ),
        autofocus: withSystem(
          {label: 'Autofocus', labelVariant: 'hidden', defaultValue: false},
          TTypeConstructor(
            qualify(pluginName('Basic'), typeName('ReverseLabelBoolean'))
          )
        ),
      },
      extraAttrs
    ),
  },
});

export default config;
